import { CreateLayoutSwitcherInstance, LayoutSwitcherUI } from "./LayoutSwitcherUI";
import { Gamecloud } from "../../../../gamecloud";

interface LayoutStorageEntry {
  id: string;
  layout: string;
}

export class LayoutSwitcher extends Gamecloud {

  private storage: LayoutStorageEntry[] = JSON.parse(localStorage.getItem('layout'));

  public constructor(private ui: LayoutSwitcherUI) {
    super();
    this.ui.onIconClick((grid: number) => this.changeLayout(grid));

    if (!this.ui.isSectionAvailableByMaxGrid(3)) {
      this.ui.disableIcon(3);
    }

    if (!this.ui.isSectionAvailableByMaxGrid(2) && !this.ui.isSectionAvailableByMaxGrid(2)) {
      this.ui.disableIcon(3);
      this.ui.disableIcon(2);
    }

    const storage = localStorage.getItem('layout');
    if (!storage) {
      localStorage.setItem('layout', JSON.stringify([]));
      this.storage = JSON.parse(localStorage.getItem('layout'));
    }
    this.setInitLayout();
  }

  private setInitLayout() {
    const find = this.storage.find((value) => value.id === this.gameserverid);
    if (find) {
      this.ui.setLayout(Number(find.layout));
    }
  }

  private changeLayout(cols: number) {
    this.ui.setLayout(cols);
    this.saveSetting(cols);
  }

  private saveSetting(setting: number) {
    const gameserverid = this.gameserverid;
    const layout: LayoutStorageEntry = {id: gameserverid, layout: setting.toString()};
    if(!this.storage.find((value) => value.id === gameserverid)) {
      this.storage.push(layout);
    } else {
      this.storage = this.storage.filter((value) => value.id !== gameserverid);
      this.storage.push(layout);
    }
    localStorage.setItem('layout', JSON.stringify(this.storage));
  }
}

export function initLayoutSwitcher() : LayoutSwitcher[] {
  return CreateLayoutSwitcherInstance().map((ui) => {
    return new LayoutSwitcher(ui);
  });
}
